<template>
  <div>
    <v-tabs v-model="tab" color="black" background-color="transparent" grow>
      <v-tab>
        Datos Válidos
        <v-badge
          :content="successDataCount"
          :value="successDataCount"
          color="green"
          class="font-weight-bold"
          inline
        />
      </v-tab>
      <v-tab>
        Datos con Error
        <v-badge
          :content="errorDataCount"
          :value="errorDataCount"
          color="error"
          class="font-weight-bold"
          inline
        />
      </v-tab>
    </v-tabs>
    <div class="mt-2">
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-data-table
            dense
            :loading="loading"
            :headers="headers"
            :items="successTabMaterials"
            item-key="codigo_material"
            class="main-table"
            :items-per-page="5"
          >
            <template #[`item.precio_con_descuento`]="{ item }">
              {{ formatNumber(item.precio_con_descuento) }}
            </template>
            <template #[`item.importe_producto`]="{ item }">
              {{ formatNumber(item.importe_producto) }}
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-data-table
            dense
            :loading="loading"
            :headers="errorHeaders"
            :items="errorTabMaterials"
            class="main-table"
            :items-per-page="5"
          />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  import numbersFormats from '@/mixins/numbersFormats';

  export default {
    name: 'UploadOrderByArchiveTabs',
    mixins: [numbersFormats],
    props: {
      successTabMaterials: {
        type: Array,
      },
      errorTabMaterials: {
        type: Array,
      },
      loading: {
        type: Boolean,
      },
    },
    data() {
      return {
        tab: 0,
        headers: [
          { text: 'Código', value: 'codigo_material' },
          { text: 'Nombre', value: 'nombre_material' },
          { text: 'Cantidad', value: 'u_pedidas', align: 'center' },
          {
            text: 'Precio descuento',
            value: 'precio_con_descuento',
            align: 'end',
          },
          { text: 'Importe', value: 'importe_producto', align: 'end' },
        ],
        errorHeaders: [
          { text: 'Índice', value: 'id_rec' },
          { text: 'Código', value: 'codigo_material' },
          { text: 'Cantidad', value: 'u_pedidas', align: 'center' },
          { text: 'Detalle', value: 'mensaje_error' },
        ],
      };
    },
    computed: {
      successDataCount() {
        return this.successTabMaterials.length;
      },
      errorDataCount() {
        return this.errorTabMaterials.length;
      },
    },
  };
</script>
<style scoped src="@/assets/css/table.css"></style>
